import { cn } from '@/lib/utils';

import LinkButton from '@/decodo/components/atoms/LinkButton';
import { gradientDecodoBorderStyling } from '@/styles/gradient';

import IconContactSales from '~/icons/send-01.svg';

export type ExtraPricingRowProps = {
  title: string;
  icon: React.ReactNode;
  description: string;
  buttonText: string;
  buttonLink: string;
};

export default function ExtraPricingRow({
  title,
  icon,
  description,
  buttonText,
  buttonLink,
}: ExtraPricingRowProps) {
  return (
    <div
      data-tracker-component='contact-card'
      className={cn(
        `shadow-card bg-base-white dark:bg-gray-dark-900 relative mb-2 w-full items-center justify-between rounded border border-none px-6 py-5 before:rounded md:flex dark:shadow-none  ${gradientDecodoBorderStyling(
          {
            borderWidth: 'p-px',
            color: 'gradient-main',
            borderRadius: 'rounded',
          }
        )}`
      )}
    >
      <div className='flex basis-1/4 items-center justify-center gap-3 pb-4 md:justify-start md:pb-0'>
        <span>{icon}</span>

        <p className='text-button-text-l font-serif'>{title}</p>
      </div>

      <div className='dark:text-gray-dark-25 text-body-m flex basis-2/4 justify-center pb-6 text-gray-500 md:justify-start md:pb-0'>
        {description}
      </div>

      <div
        className=' basis-1/4 text-right'
        data-tracker-component='contact-sales'
      >
        <LinkButton
          data-tracker-context='pricing-row-contact-us'
          variant='outlined'
          color='secondary'
          href={buttonLink}
          leftSection={
            <IconContactSales className='h-6 w-6 max-w-max scale-75 ' />
          }
          slim={false}
          fullwidth
          classNames={{
            root: 'w-full md:max-w-[160px] max-h-8',
            inner: 'flex items-center justify-center gap-4',
          }}
        >
          {buttonText}
        </LinkButton>
      </div>
    </div>
  );
}
